import { atom } from "recoil";

const searchTerm = atom({
  key: "SearchTerm",
  default: "",
});

export { searchTerm };
